import React from "react";
import { Formik, Field, Form } from "formik";
import { TextField, Loading, GalleryField, CheckBox } from "components/form";
import Modal from "components/Modal";

export default function Edit({ show, close, title, submit, item }) {
  const initialValues = {
    id: item?.id,
    title: item?.title ?? "",
    link: item?.link ?? "",
    logo: item?.logo?.id ?? null,
    backGround: item?.backGround?.id ?? null,
    status: typeof item?.status === "boolean" ? item.status : true,
  };

  return (
    <Modal show={show} handleClose={close} title={title}>
      <Formik
        initialValues={initialValues}
        onSubmit={async (values, { setSubmitting }) => {
          await submit(values, item.id);
          close();
          setSubmitting(false);
        }}
        enableReinitialize
      >
        {({ isSubmitting, dirty }) => (
          <Form>
            <div className="modal-body py-1 gap-y-3">
              <div className="intro-x md:grid md:grid-cols-2 md:gap-3">
                <Field
                  label="نام شبکه"
                  name="title"
                  component={TextField}
                  placeholder="مثلاً شبکه یک"
                />

                <Field
                  label="لینک"
                  name="link"
                  component={TextField}
                  placeholder="https://..."
                />

                <Field
                  label="لوگو"
                  name="logo"
                  dataType="id"
                  component={GalleryField}
                />

                <Field
                  label="پس‌زمینه"
                  name="backGround"
                  dataType="id"
                  component={GalleryField}
                />

                <Field label="فعال باشد؟" name="status" component={CheckBox} />
              </div>
            </div>

            <div className="modal-footer text-right">
              <button
                className="btn btn-primary w-20"
                type="submit"
                disabled={!!(isSubmitting || !dirty)}
              >
                {isSubmitting ? <Loading /> : "ذخیره"}
              </button>
              <button
                type="button"
                disabled={isSubmitting}
                onClick={close}
                className="btn btn-outline-secondary w-20 mr-1"
              >
                انصراف
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}
